const STORAGE_KEY = "aletheia_anonymous_id";

/** Stable per-browser identity used only in browser demo mode (outside Telegram). */
export function getOrCreateAnonymousId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    // localStorage unavailable (private mode, etc.) — fall back to a per-load id.
    return crypto.randomUUID();
  }
}
